// purpose: 
// store workflow state: such as: current step, active workflow, is editmode, 
// review mode? etc
// not phone, amont, etc. 

import { create } from "zustand";
import type { WorkflowStep } from "../sendWorkflow/types/workflowStep";
import type { StepKey } from  "../sendWorkflow/types/stepKey";

interface WorkflowStore {
    activeWorkflow: WorkflowStep[];
    currentStepKey: StepKey | null;
    isEditMode: boolean;
    setWorkflow: (workflow: WorkflowStep[]) => void;
    setCurrentStepKey: (stepKey: StepKey) => void;
    setIsEditMode: (isEditMode: boolean) => void;
    resetWorkflow: () => void;
}

export const useWorkflowStore =
  create<WorkflowStore>((set) => ({
    activeWorkflow: [],
    currentStepKey: null,
    isEditMode: false,
    setWorkflow: (workflow) =>
      set({
        activeWorkflow: workflow,
      }),

    setCurrentStepKey: (step) =>
      set({
        currentStepKey: step,
      }),

    setIsEditMode: (isEditMode) =>
      set({
        isEditMode,
      }),

    resetWorkflow: () =>
      set({
        activeWorkflow: [],
        currentStepKey: null,
        isEditMode: false,
      }),
  }));

//   After Workflow Store
// We will finally connect the pieces together:
// Journey Store
//       ↓
// Workflow Context
//       ↓
// Workflow Builder
//       ↓
// Workflow Store
//       ↓
// Flow Engine

//After this we'll build the Workflow Initialization Service/Hook, 
// which will be the bridge between the stores and the workflow engine.